module.exports = __webpack_public_path__ + "static/media/img_step_2.3734ed0c.jpg";